import React from 'react';
import WidgetRecommendationsCtaButtonProps from './widget-recommendations-cta-button.props';
import { UrlManager } from '@skapiec/lib-url-manager';

import './widget-recommendations-cta-button.scss';

const WidgetRecommendationsCtaButton: React.FC<WidgetRecommendationsCtaButtonProps> = ({ id, slug, color, text }) => {
    return (
        <a
            className="widget-cta-button"
            href={UrlManager.category.view({ id, slug, sort: 'rating' })}
            style={{ color }}
        >
            {text}
        </a>
    );
};

export default WidgetRecommendationsCtaButton;
